import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HeroSectionB } from '../components/HeroSectionB';
import { SignalSection } from '../components/SignalSection';
import { SymptomsSection } from '../components/SymptomsSection';
import { AnticipationSection } from '../components/AnticipationSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BibliotecaSection } from '../components/BibliotecaSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
const getVariant = (): string => {
  if (typeof window === 'undefined') return 'a';
  return new URLSearchParams(window.location.search).get('v') ?? 'a';
};
export function LandingPage() {
  const variant = getVariant();
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-372" data-mp="38i22uav52n5v">

      {/* Concepto 2: Señal con reveal secuencial */}
      <SignalSection data-id="element-373" data-mp="3i9om8uhmrsjp" />

      {/* Espejo emocional — justo después de "tu cuerpo no falló" */}
      <SymptomsSection data-id="element-374" data-mp="3n89fub2dndz6" />

      {/* Test A/B: solo el hero cambia */}
      {variant === 'b' ? <HeroSectionB data-id="element-375" data-mp="3ra3b23tszpry" /> : <HeroSection data-id="element-376" data-mp="3r9l8kpgjsfbl" />}

      {/* Concepto 3: Anticipación — el destino antes del vehículo */}
      <AnticipationSection data-id="element-377" data-mp="3jv6a9419ms" />

      {/* Concepto 4: Protocolo con journey bar + fases interactivas */}
      <ProtocolSection data-id="element-378" data-mp="1wwlks920ket8" />

      <BenefitsSection data-id="element-379" data-mp="1wx51xnjuaz67" />
      <PainSection data-id="element-380" data-mp="1wxwn04ft9ei8" />
      <TestimonialsSection data-id="element-381" data-mp="1wyg8fv4o6l10" />
      <ForWhoSection data-id="element-382" data-mp="21un48v3cqg58" />
      <BibliotecaSection data-id="element-383" data-mp="21vy7mtsvxlvt" />

      {/* Antes/Después + cierre de identidad — justo antes del CTA */}
      <DifferenceSection data-id="element-384" data-mp="356viwsyp7nrk" />

      <OfferSection data-id="element-385" data-mp="3586moss58vio" />
      <AboutSection data-id="element-386" data-mp="306zggy5ng4e4" />
      <FAQSection data-id="element-387" data-mp="307iw287tugoz" />
      <FinalCTASection data-id="element-388" data-mp="308103r0qdz7g" />

    </main>;
}